/* eslint-disable react/prop-types */
/**
 * @author Irrevaldy
 * B2B-5564 — Product Stock
 */

import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';

import ProductStockScreen from '@/screens/request-product/ProductStockScreen';

const Stack = createStackNavigator();

const ProductStockNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="ProductStockScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="ProductStockScreen"
        component={ProductStockScreen}
        options={() => ({
          title: setTitleHeader('Product Stock'),
        })}
      />
    </Stack.Navigator>
  );
};

export default ProductStockNavigator;
